import clsx from 'clsx';

interface Props<T extends string> {
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
  label: string;
  className?: string;
}

export function FilterPills<T extends string>({ options, value, onChange, label, className }: Props<T>) {
  return (
    <div role="group" aria-label={label} className={clsx('flex flex-wrap gap-2', className)}>
      {options.map((o) => (
        <button
          key={o}
          type="button"
          aria-pressed={o === value}
          onClick={() => onChange(o)}
          className={clsx(
            'min-h-11 cursor-pointer rounded-pill border border-navy-800 px-4 text-[0.9375rem] font-semibold',
            o === value ? 'bg-navy-800 text-white' : 'bg-white text-navy-800',
          )}
        >
          {o}
        </button>
      ))}
    </div>
  );
}
